import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGridContainer } from '../../containers/assignEntities/SiteGridContainer';
import { UserGridContainer } from '../../containers/assignEntities/UserGridContainer';

const AssignSiteToUsers = props => {
  const {
    allUsersData,
    loadingAllUsers,
    allSitesData,
    loadingAllSites,
    setIsReadOnlyState,
    isReadOnly,
    onResetPageOnDataChange,
    resetGridPage,
    onFilteredChange,
    rightSideGridReactTableRef,
    isRightGridFiltered,
    direction,
  } = props;

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <Field
            component={SiteGridContainer}
            name={AssignEntitiesEnum.SiteGridInfo}
            {...{
              dataSource: allSitesData,
              loadingAllSites,
              isLeftSideSiteGrid: true,
              isRightSideUserGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onResetPageOnDataChange,
              resetGridPage,
              direction,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={UserGridContainer}
            name={AssignEntitiesEnum.UserGridInfo}
            {...{
              dataSource: allUsersData,
              loadingAllUsers,
              isRightSideUserGrid: true,
              allSitesData,
              setIsReadOnlyState,
              isReadOnly,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              onResetPageOnDataChange,
              resetGridPage,
              direction,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignSiteToUsers.propTypes = {
  allUsersData: PropTypes.array.isRequired,
  allSitesData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllUsers: PropTypes.bool,
  loadingAllSites: PropTypes.bool,
  isRightGridFiltered: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
};

AssignSiteToUsers.defaultProps = {
  loadingAllUsers: false,
  loadingAllSites: false,
  isReadOnly: true,
  direction: true,
  isRightGridFiltered: false,
  rightSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  onResetPageOnDataChange: () => {},
  onFilteredChange: () => {},
};

export default AssignSiteToUsers;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignSiteToUsers.js